import { useEffect, useState } from 'react';
import { useRooms } from '../matrix/hooks/useRooms';
import { NotificationReason, type NotificationType } from '../utils/matrixClient';

export const useTechnicalMessages = () => {
  /*
    this very hook might be extendend / used in other contextes
    where a user should become aware of actions of another user;
    as we are not using Subscriptions, using Matrix as EventBus is our solution

    the idea is to write special messages to the users private Notification Channel,
    interpret these as Events and update components where appropriate

    the payload type should be "NotificationReason.EmittedEvent"

   */

  const rooms = useRooms();

  const [technicalMessages, setTechnicalMessages] = useState<NotificationType[]>([]);

  useEffect(() => {
    const notifications: NotificationType[] = [];

    rooms?.forEach((room) => {
      const events = room?.getLiveTimeline().getEvents();

      for (const matrixEvent of events) {
        const eventBody = matrixEvent.getContent().body;
        if (!eventBody) continue;
        try {
          const payload = JSON.parse(eventBody) as NotificationType;
          const content = JSON.parse(payload.content as string);
          if (payload) {
            // can be removed when typing ist consistent
            const type = (payload.type?.charAt(0).toLowerCase() + payload?.type?.slice(1)) as NotificationReason;

            // only consider payload type of emittedEvent
            if (type !== NotificationReason.EmittedEvent) continue;

            const data: NotificationType = {
              ...payload,
              date: matrixEvent.getDate() ?? new Date(),
              eventId: matrixEvent.getId(),
              type: payload.type,
              content: payload.content, // best use this field to decide where appropriate
            };
            if (content) {
              notifications.push(data);
            }
          }
        } catch {
          // silently ignore
        }
      }
    });
    const sorted = notifications.sort((a, b) => (b.date?.getTime() ?? 0) - (a.date?.getTime() ?? 0));
    setTechnicalMessages(sorted);
  }, [rooms]);

  return { technicalMessages };
};
